/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Hero_EyebrowInputs */

const es_l7_hero_eyebrow = /** @type {(inputs: L7_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler Lista 7ª`)
};

const gl_l7_hero_eyebrow = /** @type {(inputs: L7_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro Lista 7ª`)
};

const en_l7_hero_eyebrow = /** @type {(inputs: L7_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List 7 rental`)
};

/**
* | output |
* | --- |
* | "List 7 rental" |
*
* @param {L7_Hero_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_hero_eyebrow = /** @type {((inputs?: L7_Hero_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Hero_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_hero_eyebrow(inputs)
	if (locale === "en") return en_l7_hero_eyebrow(inputs)
	return es_l7_hero_eyebrow(inputs)
});